import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./app/App";
import { createAppQueryClient } from "./app/query-client";
import { SessionProvider } from "./features/auth/SessionProvider";
import { PlatformApiProvider } from "./features/platform/platform/PlatformApiProvider";
import { normalizeLegacyHash } from "./features/platform/model/routes";
import { ThemeProvider } from "./shared/ui/ThemeProvider";
import { ConfirmProvider, ToastProvider } from "./shared/ui/overlays";
import "./styles.css";
import "./design-system.css";

const rootElement = document.getElementById("root");

if (rootElement === null) {
  throw new Error("Elemento raiz da fundação React não encontrado.");
}

const normalizedHash = normalizeLegacyHash(window.location.hash);
if (normalizedHash !== null && normalizedHash !== window.location.hash) {
  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}${window.location.search}${normalizedHash}`,
  );
}

const queryClient = createAppQueryClient();

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <ConfirmProvider>
            <PlatformApiProvider>
              <SessionProvider>
                <App />
              </SessionProvider>
            </PlatformApiProvider>
          </ConfirmProvider>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
